import React, { useMemo } from 'react';

import { Modal, Panel } from '@myhealth-raccoon/components';

import { SearchResults } from './SearchResults';
import { useBreakpoints } from 'src/hooks/useBreakpoints';
import { StateEnum } from 'src/services/telehealth';
import { useDispatch } from 'src/store';
import { setAppointmentFromTelehealthSlot } from 'src/store/appointment';

type Props = {
    isOpen: boolean;
    setOpen(isOpen: boolean): void;
    state?: StateEnum;
};

export function TelehealthNowPickerModal({ isOpen, setOpen, state }: Props) {
    const breakpoint = useBreakpoints();
    const dispatch = useDispatch();

    const content = useMemo(
        () => (
            <SearchResults
                className="p-4"
                query={{ state }}
                onClick={async (timeSlot) => {
                    await dispatch(setAppointmentFromTelehealthSlot(timeSlot));
                    // await authService.ConnectBookingApp(timeSlot.siteId, isNewPatient);
                    setOpen(false);
                }}
            />
        ),
        [dispatch, setOpen, state]
    );

    if (['lg', 'xl', '2xl'].indexOf(breakpoint) >= 0) {
        return (
            <Modal open={isOpen} onClose={() => setOpen(false)} size="lg" hideX unstyled>
                <div className="pt-6">
                    <h3 className="px-4 text-lg font-semibold text-gray-900">Select a GP</h3>
                    <p className="px-4">
                        Please choose another GP from the list below. Times are displayed in your local time zone.
                    </p>
                    {content}
                </div>
            </Modal>
        );
    }

    return (
        <Panel
            open={isOpen}
            setOpen={setOpen}
            attachedTo="bottom"
            title={
                <>
                    <h3 className="px-3 pt-1.5 text-lg font-semibold text-gray-900">Select a GP</h3>
                    <p className="px-3">
                        Please choose another GP from the list below. Times are displayed in your local time zone.
                    </p>
                </>
            }
        >
            {content}
        </Panel>
    );
}
